/** The store holds the farm ID and field IDs that belong to the logged in user */
const initialState = {
    image: "",
    result: ""
};

export default initialState;
